/**
 * @ngdoc directive
 * @name drvContactSelector
 * 
 * @description
 * Allows the selection of contacts into a 'chips' control. Utilises 'autocomplete' functionality with the supplied list of contacts.
 *
 * @param {array} value - Array of contacts which have been selected
 * @param {array} contacts - Array of contacts which will be used for autocomplete functionality
 * @param {string} label - Label to be shown for the contact selector
 * @param {bool} readOnly - Flag for read only mode, where the attachment list cannot be modified.
 * @param {bool} allowNewContact - Flag to allow new contacts to be added which are not in the supplied list. Optional.
 * @param {string} newContactType - The type (Usage) of the contact that can be added. E.g. Email, SMS, Fax etc. Optional.
 * @param {bool} mandatory - Flag mandatory mode, where at least one value is required.
 */

(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvContactSelector', drvContactSelector);

    drvContactSelector.$inject = [];

    function drvContactSelector() {
        var directive = {
            templateUrl: 'app/controls/select/contact-selector.tmpl.html',
            scope: {
            },
            controller: drvContactSelectorCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                value: '=',
                contacts: '=',
                label: '=',
                readOnly: '=',
                allowNewContact: '<?',
                newContactType: '<?',
                hideShowSmsOnlyFooter: '<?',
                mandatory: '@?'
            }
        };

        return directive;
    }

    drvContactSelectorCtrl.$inject = ['$scope', 'ContactService'];

    function drvContactSelectorCtrl($scope, ContactService) {
        /* jshint validthis:true */
        var drvCtrl = this;
        drvCtrl.footerDetails = { ShowSMSOnlyIsVisible: false, ShowSMSOnly: false };
        drvCtrl.contactInvalid = contactInvalid;
        drvCtrl.toolTipHtml = toolTipHtml;
        drvCtrl.showContactInformation = showContactInformation;
        drvCtrl.addContact = addContact;
        drvCtrl.getChipLabel = getChipLabel;
        Object.defineProperty(drvCtrl, 'sortedContacts', { get: getSortedContacts });

        activate();

        function activate() {
            if (!_.isNil(drvCtrl.newContactType) && drvCtrl.newContactType === 'SMS' && drvCtrl.hideShowSmsOnlyFooter !== true)
                drvCtrl.footerDetails.ShowSMSOnlyIsVisible = true;
        }

        /**
         *
         * Gets label from the supplied chip
         *
         * @returns {string} representing the chip label
         */
        function getChipLabel(chip) {
            var result = '';
            if (chip.ReferenceContact === true && !_.isNil(chip.Name) && chip.Name !== '') {
                result += chip.Name;
            }
            else if (angular.isDefined(chip.Name) && chip.Name !== null && chip.Name !== '') {
                result += chip.Name;

                if (!_.isNil(chip.Value) && chip.Value !== '')
                    result += ' <' + chip.Value + '>';
            } else {
                result += chip.Value;
            }

            return result;
        }

        /**
         *
         * Determines if the contact information is invalid for the supplied chip.
         * If so, the validation message will be returned. E.g. 'Email Address is blocked'.
         *
         * @returns {string} Returns a validation message if the chip is invalid, otherwise null if valid
         */
        function contactInvalid(chip) {
            return ContactService.contactInvalid(chip);
        }

        /**
         *
         * Sorts the contact list by Name and then Value.
         *
         * @returns {array} List of sorted contacts
         */
        function getSortedContacts() {
            var filteredContacts = _.filter(drvCtrl.contacts, function (contact) {
                return (drvCtrl.footerDetails.ShowSMSOnly === false ||
                    (!_.isNil(contact.ReferenceContact) && contact.ReferenceContact === true) ||
                    (!_.isNil(contact.SMS) && contact.SMS === true));
            });
            
            // If all of the contacts are system contacts, show all contacts.
            if (filteredContacts.length === 0 && drvCtrl.contacts.length > 0) {
                drvCtrl.footerDetails.ShowMore = true;
            }

            if (!angular.equals(getSortedContacts.contactList, filteredContacts)) {
                getSortedContacts.contactList = filteredContacts;
            }

            return getSortedContacts.contactList;
        }

        /**
         *
         * Creates the html code to be shown for the contact tooltip
         *
         * @returns {string} html code describing the supplied contact
         */
        function toolTipHtml(contact) {
            return ContactService.getToolTipHtml(contact);
        }

        /**
         *
         * Checks the contact to determine if a tool tip shown be shown
         *
         * @returns {bool} does the contact contain information that needs to be shown in a tool tip
         */
        function showContactInformation(contact) {
            return ContactService.showContactInformation(contact);
        }

        /*
         *  Will add the supplied contact value into the contacts list if it does not already exist and will then return the contact in a compatible format.
         *
         *  @returns {object} Returns contact in format that is compatible with the contact data structure.
         */
        function addContact(contactString) {
            var contact = { Value: contactString, Usage: drvCtrl.newContactType };

            if (!_.find(drvCtrl.contacts, function (contact) { return contact.Value === contactString; })) {
                drvCtrl.contacts.unshift(contact);
            }

            return contact;
        }
    }
})();